import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import SafeImage from "../../../layout/reusable/SafeImage";
import { getPortfolios } from "../../../utils/cms.utils";

const MAX_ITEMS = 5;

const Portfolio = () => {
    const [portfolioItems, setPortfolioItems] = useState([]);

    const prevRef = useRef(null);
    const nextRef = useRef(null);

    /* ================= LOAD CMS ================= */
    useEffect(() => {
        const data = getPortfolios();
        setPortfolioItems(Array.isArray(data) ? data : []);
    }, []);

    /* ================= RANDOM ONCE ================= */
    const randomPortfolios = useMemo(() => {
        if (!portfolioItems.length) return [];
        const shuffled = [...portfolioItems].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, MAX_ITEMS);
    }, [portfolioItems]);

    const slidesData = useMemo(() => {
        if (!randomPortfolios.length) return [];
        return [
            ...randomPortfolios,
            { id: "__view_more__", isViewMore: true },
        ];
    }, [randomPortfolios]);

    /* ✅ RETURN SETELAH SEMUA HOOK */
    if (!slidesData.length) return null;

    return (
        <section className="portfolio__one section-padding">
            <div className="container">
                {/* ===== HEADER ===== */}
                <div className="row al-end">
                    <div className="col-lg-7">
                        <div className="portfolio__one-title lg-t-center lg-mb-20">
                            <span className="section-kicker portfolio__one_title_subs text-center">
                                Our Projects and Portfolio
                            </span>
                            <h1>Discover Our Builds</h1>
                            <h4>Delivering Reliable Engineering Solutions</h4>
                        </div>
                    </div>

                    <div className="col-lg-5 d-flex justify-content-lg-end justify-content-center">
                        <div className="slider-arrow-portfolio">
                            <div ref={prevRef} className="slider-arrow-portfolio-prev">
                                <i className="fa-regular fa-arrow-left-long"></i>
                            </div>
                            <div ref={nextRef} className="slider-arrow-portfolio-next">
                                <i className="fa-regular fa-arrow-right-long"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ===== SLIDER ===== */}
                <div className="row mt-60">
                    <div className="col-xl-12 swiper">
                        <Swiper
                            modules={[Autoplay, Navigation]}
                            spaceBetween={30}
                            slidesPerView={3}
                            loop={false}
                            autoplay={{
                                delay: 4500,
                                disableOnInteraction: false,
                            }}
                            navigation={{
                                prevEl: prevRef.current,
                                nextEl: nextRef.current,
                            }}
                            onBeforeInit={(swiper) => {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                            }}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                768: { slidesPerView: 2 },
                                1200: { slidesPerView: 3 },
                            }}
                        >
                            {slidesData.map((item) => (
                                <SwiperSlide key={item.id}>
                                    {item.isViewMore ? (
                                        <Link
                                            to="/portfolio"
                                            className="portfolio__view-more"
                                        >
                                            <div className="portfolio__view-more-inner">
                                                <i className="flaticon flaticon-right-up"></i>
                                                <h4>View All Portfolio</h4>
                                                <p>Explore Our Complete Projects</p>
                                            </div>
                                        </Link>
                                    ) : (
                                        <Link
                                            to={`/portfolio/${item.id}`}
                                            className="portfolio__card mx-auto"
                                        >
                                            <div className="portfolio__card-media">
                                                <SafeImage
                                                    isCoverImage
                                                    src={item.images?.[0]}
                                                    alt={item.title}
                                                />
                                                <div className="portfolio__card-overlay"></div>
                                            </div>

                                            <div className="portfolio__card-content">
                                                {item.subtitle && (
                                                    <span className="portfolio__card-subtitle">
                                                        {item.subtitle}
                                                    </span>
                                                )}
                                                <h4>{item.title}</h4>
                                                <p className="portfolio__card-link">
                                                    View Project{" "}
                                                    <i className="flaticon-right-up"></i>
                                                </p>
                                            </div>
                                        </Link>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
